<div class="landing-wrapper">
  <div
    *ngIf="showAuthenticatingOverlay"
    class="auth-screen-loader"
    role="status"
    aria-live="polite"
    aria-busy="true"
  >
    <div class="auth-screen-loader__panel">
      <p class="auth-screen-loader__title">Authenticating...</p>
      <p class="auth-screen-loader__subtitle">Loading your session</p>
    </div>
  </div>

  <!-- Hero -->
  <div class="hero">
    <div class="hero-overlay"></div>
    <div class="hero-content">
      <img src="assets/landing/logo.png" alt="FORWARD logo" class="hero-logo" />
      <h1 class="hero-title">FORECASTING SOLUTIONS</h1>
      <p class="hero-subtitle">BY ZS</p>
    </div>
  </div>

  <!-- Lower panel -->
  <div class="lower-panel">
    <p class="welcome-text">
      Welcome, <strong>{{ userName }}</strong>
    </p>

    <div class="cards-row">
      <div
        class="landing-card"
        *ngFor="let card of cards"
      >
        <img
          *ngIf="card.icon"
          [src]="card.icon"
          class="card-watermark"
          alt=""
          aria-hidden="true"
        />
        <div class="card-body-content">
          <h3 class="card-title">{{ card.title }}</h3>
          <p class="card-description">{{ card.description }}</p>
        </div>
        <button
          class="card-view-btn"
          [disabled]="isCardButtonDisabled(card)"
          (click)="navigateCard(card)"
        >
          View
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>
